const UserRoleEnum = {
    //Super Admin
    superAdmin: 'super-admin',
    
    //Company
    companyMember: 'company-member',
    companyMemberAdmin: 'company-member-admin',
    companyMemberCommercial: 'company-member-commercial',

    //Agency
    agencyMember: 'agency-member',
    agencyAdmin: 'agency-admin',
    planner: 'planner',
    mediaDirector: 'media-director',

    //Commercials
    superModeratorAgency: 'super-moderator-agency',
    superModeratorMediaCompany: 'super-moderator-media-company',

    //Advertiser
    advertiser: 'advertiser'
  };

  export default UserRoleEnum;
